<div
  class="h-full bg-white transition-all duration-75 shadow-md relative overflow-x-hidden flex flex-col border-2 border-slate-200 lg:visible md:visible sm:invisible invisible"
  [ngClass]="{ 'w-74': !collapse, 'w-16': collapse }"
>
  <!-- Header (fijo) -->
  <div
    class="w-full flex-shrink-0 flex items-center border-b border-slate-100"
    [ngClass]="{
      'flex-col justify-center py-4': collapse,
      'justify-between p-3': !collapse,
    }"
  >
    @if (!collapse) {
      <img src="logo.png" alt="" class="w-14 img" />
      <p
        class="p-0 m-0 leading-none opacity-0 mx-2 transition-all duration-500 opacity-100"
      >
        <b class="text-primary-900">Sistema</b>
        de gestión digital
      </p>
    }
    <div
      class="collapse-toggle rounded-md hover:bg-slate-100 transition-colors cursor-pointer flex items-center justify-center"
      [ngClass]="{ 'w-10 h-10': collapse, 'p-3': !collapse }"
      (click)="collapse = !collapse"
    >
      <c-button-animated class="pointer-events-none" [(collapse)]="collapse" />
    </div>
  </div>

  <!-- Navegación (scroll propio) -->
  <div class="flex-1 overflow-y-auto py-3 w-full">
    @for (m of menu; track $index) {
      <c-item
        [isForRoot]="m.isForRoot"
        [titulo]="m.titulo"
        [iconoActivo]="m.iconoActivo"
        [iconoInactivo]="m.iconoInactivo"
        [routerLink]="m.routerLink"
        [collapse]="collapse"
      />
    }
  </div>

  <!-- Sección inferior (fija) -->
  <div class="flex-shrink-0 border-t border-slate-100 py-3 w-full">
    <div
      #trigger
      routerLink="/home"
      class="w-full flex justify-start items-center cursor-pointer transition-all duration-200 group relative rounded-md py-2 pl-4 pr-3 hover:bg-slate-50"
      (mouseenter)="openSwitcher(trigger)"
      (mouseleave)="closeSwitcher()"
    >
      <div
        class="w-5 h-5 flex-shrink-0 relative mr-2"
        [pTooltip]="tooltip2"
        [tooltipDisabled]="!collapse"
        #triggerNotCollapse
      >
        <img
          src="svg/switch-fill.svg"
          alt="Icon"
          class="icon w-5 h-5 object-contain"
        />
      </div>
      @if (!collapse) {
        <a class="transition-all duration-200 text-slate-600">
          Cambiar sistema
        </a>
      }

      <!-- PANEL FLOTANTE: centrado verticalmente respecto al botón -->
      <div
        class="fixed z-50 bg-white rounded-xl shadow-xl border border-gray-200 p-4 min-w-65 transition-all duration-200"
        *ngIf="showSwitcher"
        [ngStyle]="{
          top: panelPosition.top + 'px',
          left: panelPosition.left + 'px',
          transform: 'translateY(-50%)',
        }"
        (click)="$event.stopPropagation()"
        (mouseenter)="keepOpen()"
        (mouseleave)="closeSwitcher()"
      >
        <div class="grid grid-cols-2 gap-4">
          @for (item of switcherItems; track item.route) {
            <div
              class="flex flex-col items-center gap-2 p-3 rounded-lg transition relative"
              [routerLink]="!item.locked ? item.route : null"
              [ngClass]="{
                'hover:bg-gray-100 cursor-pointer': !item.locked,
                'bg-gray-200 cursor-not-allowed': item.locked,
              }"
            >
              <img [src]="item.icon" [alt]="item.label" width="40" />
              <p class="text-sm font-medium">{{ item.label }}</p>
              @if (item.locked) {
                <i
                  class="pi pi-lock font-bold text-gray-500 absolute bottom-2 right-2"
                ></i>
              }
            </div>
          }
        </div>
      </div>
    </div>

    <div
      class="w-full flex justify-start items-center cursor-pointer transition-all duration-200 mt-1 rounded-md py-2 pl-4 pr-3 hover:bg-danger/10 group/logout"
      (click)="logout()"
      [pTooltip]="tooltip"
      [tooltipDisabled]="!collapse"
    >
      <div class="w-5 h-5 flex-shrink-0 relative mr-2">
        <img
          src="svg/logout.svg"
          alt="Icon"
          class="icon w-5 h-5 object-contain"
        />
      </div>
      @if (!collapse) {
        <a
          class="transition-all duration-200 text-slate-600 group-hover/logout:text-danger"
        >
          Cerrar sesión
        </a>
      }
    </div>
  </div>
</div>

<ng-template #tooltip>
  <div>
    <small>Cerrar sesión</small>
  </div>
</ng-template>

<ng-template #tooltip2>
  <div>
    <small>Cambiar sistema</small>
  </div>
</ng-template>

<c-dialog #dialog />
